import axios from 'axios'
import qs from 'qs'

const instance = axios.create({
  withCredentials: false,
  xsrfCookieName: null,
  paramsSerializer: (params) =>
    qs.stringify(params, {
      filter: (_prefix, value) => {
        if (value === null) {
          return 'null'
        }

        return value
      },
      arrayFormat: 'brackets'
    })
})

// TODO add back
// instance.interceptors.request.use(
//   (config) => {
//     log.info(
//       // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
//       { category: LogCategories.NETWORK, data: { ...config.params } },
//       `${config.method ?? ''} ${config.url ?? ''} - start`
//     )
//     return config
//   },
//   function (error) {
//     // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
//     log.error({ category: LogCategories.NETWORK, data: { error } }, `Request error`)

//     return Promise.reject(error)
//   }
// )

// instance.interceptors.response.use(
//   function (response) {
//     log.info(
//       // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
//       { category: LogCategories.NETWORK, data: { ...response.data } },
//       `${response.config.method ?? ''} ${response.config.url ?? ''} - ${response.status} - success`
//     )
//     return response
//   },
//   function (error) {
//     // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
//     log.error({ category: LogCategories.NETWORK, data: { error } }, `Response error`)
//     return Promise.reject(error)
//   }
// )

export default instance
